import { useRef, useState, useEffect } from 'react';

function useTimer(duration, callback) {
  if (duration === void 0) {
    duration = 0;
  }

  var timer = useRef();

  var _React$useState = useState({
    remaining: duration,
    started: null
  }),
      tracker = _React$useState[0],
      setTracker = _React$useState[1];

  useEffect(function () {
    if (duration) {
      if (tracker.started) {
        timer.current = window.setTimeout(callback, tracker.remaining);
      } else {
        clearTimeout(timer.current);
      }
    }

    return function () {
      clearTimeout(timer.current);
    };
  }, [tracker.started]);
  return {
    running: !!tracker.started,
    start: function start() {
      setTracker({
        remaining: duration,
        started: Date.now()
      });
    },
    pause: function pause() {
      if (tracker.started) {
        setTracker({
          remaining: tracker.remaining - (Date.now() - tracker.started),
          started: null
        });
      }
    },
    resume: function resume() {
      if (tracker.remaining && !tracker.started) {
        setTracker({
          remaining: tracker.remaining,
          started: Date.now()
        });
      }
    }
  };
}

export default useTimer;
//# sourceMappingURL=useTimer.js.map
